import { render, staticRenderFns } from "./Atualiza.vue?vue&type=template&id=48c1eb27&scoped=true&"
import script from "./Atualiza.vue?vue&type=script&lang=js&"
export * from "./Atualiza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1eb27",
  null
  
)

export default component.exports